import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Loader({ fullscreen, label, className }: { fullscreen?: boolean; label?: string; className?: string }) {
  const inner = (
    <div className={cn('flex items-center justify-center gap-3 text-ink-500 dark:text-muted-foreground', className)}>
      <Loader2 className="h-5 w-5 animate-spin text-brand-500" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
  if (fullscreen) {
    return <div className="flex min-h-[50vh] w-full items-center justify-center py-16">{inner}</div>;
  }
  return inner;
}
